import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const DesignEngineeringData = () => {
    
    const sections = [
        { label: "Consultant", value: "Consultant", items: [] },
        { label: "Discipline", value: "Discipline", items: [] },
        { label: "Document Type", value: "DocumentType", items: [] },
        { label: "Status", value: "Status", items: [] },
        { label: "IE Approval Status", value: "IEApprovalStatus", items: [] },
        { label: "GFC Approval Status", value: "GFCApprovalStatus", items: [] },
    ];

    return (
        <MasterData pageTitle="DesignAndEngineeringTracker" sections={sections} />
    );
};

export default DesignEngineeringData;